import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-search-bar',
  standalone: true,
  imports: [CommonModule, FormsModule, MatCardModule],
  templateUrl: './searchbar.component.html',
})
export class SearchBarComponent {

  @ViewChildren('inputRef') inputRefs!: QueryList<ElementRef<HTMLInputElement>>;

  /** Chiavi del filtro di ricerca */
  @Input() filterFields: string[] = [];

  /** Mappa: filtro -> colonne (in OR) su cui agisce */
  @Input() filterMap: Record<string, string[]> = {};

  /** Etichette visualizzate per ciascun filtro */
  @Input() filterLabels: Record<string, string[]> = {};

  /** Stato locale dei filtri (chiave -> valore) */
  filters: Record<string, string> = {};

  /** Emesso ad ogni variazione di filtro */
  @Output() filtersChanged = new EventEmitter<Record<string, string>>();

  onInputChange(field: string, value: string): void {
    this.filters[field] = value;
    console.log('filtri passati al be', { ...this.filters });
    this.filtersChanged.emit({ ...this.filters });
  }

  reset(): void {
    console.log('reset search bar', this.filters);
    this.filters = {};
    this.inputRefs.forEach(ref => ref.nativeElement.value = '');
    this.filtersChanged.emit({});
  }
}